var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuterLineRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outer-line-right",
    width: 225,
    height: 49,
    viewBox: "0 0 225 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.915 8.55039C8.32676 8.55039 0.553928 16.3232 0.553928 25.9115C0.553928 35.4998 8.32676 43.2726 17.915 43.2726V8.55039ZM17.915 25.9115V43.2726H196.387V25.9115V8.55039H17.915V25.9115Z",
    fill: "#5FD9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.194 21.5805C225.414 23.7807 225.414 27.3479 223.194 29.548L204.01 48.5556C200.428 52.1048 194.304 49.5911 194.304 44.5719L194.304 6.55668C194.304 1.53743 200.428 -0.976231 204.01 2.57292L223.194 21.5805Z",
    fill: "#5FD9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterLineRight);
export default __webpack_public_path__ + "static/media/outer-line-right.5dd44286e3d744c40a55f5490f7d676d.svg";
export { ForwardRef as ReactComponent };